var map = {
	"./Auth/Login": 9011,
	"./Auth/Login.vue": 9011,
	"./BatchSales/Create": 1,
	"./BatchSales/Create.vue": 1,
	"./BatchSales/Edit": 8479,
	"./BatchSales/Edit.vue": 8479,
	"./BatchSales/Index": 9912,
	"./BatchSales/Index.vue": 9912,
	"./Batches/Create": 9661,
	"./Batches/Create.vue": 9661,
	"./Batches/Edit": 508,
	"./Batches/Edit.vue": 508,
	"./Batches/Index": 5186,
	"./Batches/Index.vue": 5186,
	"./Cart/Index": 5903,
	"./Cart/Index.vue": 5903,
	"./Contacts/Create": 9363,
	"./Contacts/Create.vue": 9363,
	"./Contacts/Edit": 7733,
	"./Contacts/Edit.vue": 7733,
	"./Contacts/Index": 2834,
	"./Contacts/Index.vue": 2834,
	"./Customers/Create": 1976,
	"./Customers/Create.vue": 1976,
	"./Customers/Edit": 1113,
	"./Customers/Edit.vue": 1113,
	"./Customers/Index": 7433,
	"./Customers/Index.vue": 7433,
	"./Dashboard/Index": 6165,
	"./Dashboard/Index.vue": 6165,
	"./Discharges/Create": 5594,
	"./Discharges/Create.vue": 5594,
	"./Discharges/Edit": 5093,
	"./Discharges/Edit.vue": 5093,
	"./Discharges/Index": 8445,
	"./Discharges/Index.vue": 8445,
	"./DiscountedLoadingProducts/Create": 4832,
	"./DiscountedLoadingProducts/Create.vue": 4832,
	"./Home/Coupon": 187,
	"./Home/Coupon.vue": 187,
	"./Home/Index": 838,
	"./Home/Index.vue": 838,
	"./Home/Participate": 7681,
	"./Home/Participate.vue": 7681,
	"./Home/Privacy-policy": 1304,
	"./Home/Privacy-policy.vue": 1304,
	"./Home/Social": 4527,
	"./Home/Social.vue": 4527,
	"./Home/TerminiCondizioni": 1163,
	"./Home/TerminiCondizioni.vue": 1163,
	"./LoadingProducts/Create": 3297,
	"./LoadingProducts/Create.vue": 3297,
	"./Organizations/Create": 3330,
	"./Organizations/Create.vue": 3330,
	"./Organizations/Edit": 3839,
	"./Organizations/Edit.vue": 3839,
	"./Organizations/Index": 7439,
	"./Organizations/Index.vue": 7439,
	"./Products/Create": 5191,
	"./Products/Create.vue": 5191,
	"./Products/Edit": 7869,
	"./Products/Edit.vue": 7869,
	"./Products/Index": 6617,
	"./Products/Index.vue": 6617,
	"./Reports/Index": 3223,
	"./Reports/Index.vue": 3223,
	"./Sales/Create": 3938,
	"./Sales/Create.vue": 3938,
	"./Sales/Edit": 9546,
	"./Sales/Edit.vue": 9546,
	"./Sales/Index": 9503,
	"./Sales/Index.vue": 9503,
	"./Users/Create": 3704,
	"./Users/Create.vue": 3704,
	"./Users/Edit": 6046,
	"./Users/Edit.vue": 6046,
	"./Users/Index": 2466,
	"./Users/Index.vue": 2466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;